import {http} from './config/config-receituario'

const headers = (token) => ({
    'Authorization':token,
    'Content-Type': 'application/json'
})

export default{
    listar:(token)=>{
        return http.get('tipo_conta',{
            headers: headers(token)
        })
    },
    listBankAccounts:(token)=>{
        return http.get('tipo_conta',{
            headers: headers(token)
        }).then((response) => {
            if (response.data && response.data.sucesso === false) {
                return {
                    ...response,
                    data: {
                        ...response.data,
                        tipoContas: []
                    }
                }
            }
            return response
        })
    },
    salvar:(token, tipoConta)=>{
        return http.post('tipo_conta', tipoConta,{
            headers: headers(token)
        })
    }, 
    atualizarTipoConta:(token, tipoConta) =>{
        return http.put('tipo_conta/'+tipoConta.id,tipoConta,{
            headers: headers(token)
        })
    }, 
    deleteTipoConta:(token, id)=>{
        return http.delete('tipo_conta/'+id,{
            headers: headers(token)
        })
    }
}
